import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';

const CustomTextField = ({
  type = 'text',
  rangeMin,
  rangeMax,
  lengthMin,
  lengthMax,
  value: controlledValue,
  onChange,
  ...props
}) => {
  const [value, setValue] = useState(controlledValue ?? "");
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState('');

  useEffect(() => {
    setValue(controlledValue ?? "");
  }, [controlledValue]);

  const validate = (newValue) => {
    if (newValue.trim() === '') {
        setError(false);
        setHelperText('');
        return true;
      }

    if (type === 'number') {
        if (!/^\d+$/.test(newValue)) {
          setError(true);
          setHelperText('Only whole numbers are allowed');
          return false;
        }
        const numericValue = parseFloat(newValue);
        if ((rangeMin !== undefined && numericValue < rangeMin) || (rangeMax !== undefined && numericValue > rangeMax)) {
          setError(true);
          setHelperText(`Value must be between ${rangeMin} and ${rangeMax}`);
          return false;
        }
      } else if (type === 'double') {
        if (!/^\d+\.\d{1,2}$/.test(newValue)) {
          setError(true);
          setHelperText('Only numbers with up to 2 decimal places are allowed');
          return false;
        }
        const numericValue = parseFloat(newValue);
        if ((rangeMin !== undefined && numericValue < rangeMin) || (rangeMax !== undefined && numericValue > rangeMax)) {
          setError(true);
          setHelperText(`Value must be between ${rangeMin} and ${rangeMax}`);
          return false;
        }
      } else if (type === 'text') {
        if ((lengthMin !== undefined && newValue.length < lengthMin) || (lengthMax !== undefined && newValue.length > lengthMax)) {
          setError(true);
          setHelperText(`Text length must be between ${lengthMin} and ${lengthMax} characters`);
          return false;
        }
      }
      setError(false);
      setHelperText('');
      return true;
  };

  const handleChange = (e) => {
    const newValue = e.target.value;
    if (validate(newValue)) {
      setValue(newValue);
      if (onChange) {
        onChange(newValue);
      }
    }
  };

  const handleKeyPress = (e) => {
    const newValue = e.target.value + e.key;
    if (type === 'number' && !/^\d+$/.test(newValue)) {
      e.preventDefault();
    } else if (type === 'double' && !/^\d*(\.\d{0,2})?$/.test(newValue)) {
      e.preventDefault();
    }
  };

  return (
    <TextField
      {...props}
      type={type === 'double' ? 'text' : type}
      value={value}
      onChange={handleChange}
      onKeyUp={handleKeyPress}
      error={error}
      helperText={helperText}
    />
  );
};

export default CustomTextField;
